<template>
  <div style="height: inherit">
    <!--IF HLINE-->
    <show-line v-if="object.type == 'HLINE'" :clo="object" />

    <!--Showing Sound Box-->
    <show-sound-box
      v-if="object.type == 'SOUND-BOX'"
      :sound_box="object.sound_box"
    ></show-sound-box>
    
    <!--Showing Shapes-->
    <show-shape
      v-if="object.type == 'SHAPES'"
      :shape="object.shapes"
    ></show-shape>

    <!--Showing Shapes-II-->
    <show-shapes
      v-if="object.type == 'SHAPES-II' && object.shapes_grid"
      :is_selectable="object.shapes_grid && object.shapes_grid.is_selectable"
      :shapes="object.shapes_grid && object.shapes_grid"
    ></show-shapes>

    <!--If Clock-->
    <show-clock v-if="object.type == 'CLOCK'" :clock="object.clock" />

    <!--If Protractor-->
    <show-protractor
      v-if="object.type == 'PROTRACTOR'"
      :protractor="object.protractor"
    />

    <!--If Ruler-->
    <show-ruler v-if="object.type == 'RULER'" :ruler="object.ruler" />

    <!--If Multi-chars-->
    <show-multi-chars
      v-if="object.type == 'MULTI-CHARS'"
      :multi_chars="object.multi_chars"
      @input="receiveMultiCharsResponse"
    />

    <!--DISPLAYING INPUT BOX-->
    <b-input
      :class="
        `clinp ${object.input_type && object.input_type == 'SM' ? 'is-sm' : ''}`
      "
      :size="$common.customLayoutInputSize(object.input_size)"
      v-if="object.type == 'INPUT'"
      v-model="object.response"
      @input="emitData()"
    ></b-input>

    <!--DISPLAYING PICTURE LIBRARY IMAGE-->
    <show-image
      v-if="
        object.type == 'IMAGE' &&
          object.picture_type == 'P' &&
          object.picture_library &&
          object.picture_library.file
      "
      :src="object.picture_library.file"
      :width="object.width"
      :height="object.height"
    />

    <!--DISPLAYING CLIPART IMAGE-->
    <show-image
      v-else-if="
        object.type == 'IMAGE' &&
          object.picture_type == 'C' &&
          object.clipart.file
      "
      :src="object.clipart.file"
      :width="object.width"
      :height="object.height"
      :tts="object.clipart_tts_text"
    />

    <!--DISPLAYING CLIPART LAYER-->
    <show-clipart-layer
      v-if="object.type == 'IMAGE' && object.picture_type == 'CL'"
      :layers="object.layers"
    ></show-clipart-layer>

    <!--DISPLAYING TEXT-->
    <div
      v-if="object.type == 'TEXT'"
      :style="
        `white-space:pre-wrap;font-size:${object.font_size}px;font-weight:${
          object.is_bold ? 'bold' : 'normal'
        };${object.text_align ? `text-align:${object.text_align}` : ''}`
      "
    >
      {{ object.text }}
    </div>

    <!--DISPLAYING QUESTION TEXT-->
    <div
      v-if="object.type == 'QTEXT'"
      class="title is-4"
      :style="
        `white-space:pre-wrap;${
          object.text_align ? `text-align:${object.text_align}` : ''
        }`
      "
    >
      {{ object.text }}
    </div>

    <!--DISPLAYING HTML TEXT-->
    <quill-view
      v-if="object.type == 'HTMLTEXT'"
      :data="object.text"
    ></quill-view>
  </div>
</template>
<script>
import ShowImage from "@/components/General/ShowImage";
import ShowClipartLayer from "@/components/Question/ShowClipartLayer";
import ShowClock from "@/components/Question/Clock/ShowClock";
import ShowShapes from "@/components/Question/Shapes/ShowShapes";
import ShowProtractor from "@/components/Question/Protractor/ShowProtractor";
import ShowRuler from "@/components/Question/Ruler/ShowRuler";
import ShowMultiChars from "@/components/Question/MultiChars/ShowMultiChars";
import ShowLine from "@/components/Question/CustomLayout/Line/ShowLine";
import ShowShape from "@/components/Question/CustomLayout/Shapes/ShowShape";
import ShowSoundBox from "@/components/Question/CustomLayout/CustomSound/ShowSoundBox";
import QuillView from "@/components/Editor/QuillView";
export default {
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      object: this.value,
    };
  },
  components: {
    ShowImage,
    ShowClipartLayer,
    QuillView,
    ShowClock,
    ShowProtractor,
    ShowRuler,
    ShowMultiChars,
    ShowLine,
    ShowShape,
    ShowShapes,
    ShowSoundBox
  },
  methods: {
    receiveMultiCharsResponse(value) {
      this.object = { ...this.object, is_correct: value };
      this.emitData();
    },
    emitData() {
      this.$emit("input", this.object);
    },
    checkNested(obj /*, level1, level2, ... levelN*/) {
      var args = Array.prototype.slice.call(arguments, 1);
      for (var i = 0; i < args.length; i++) {
        // eslint-disable-next-line no-prototype-builtins
        if (!obj || !obj.hasOwnProperty(args[i])) {
          return false;
        }
        obj = obj[args[i]];
      }
      return true;
    },
  },
  watch: {
    value: {
      handler: function(new_val) {
        this.object = new_val;
      },
      deep: true,
    },
  },
};
</script>
